import { FC, ReactElement, Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { I18nProvider } from '../_payairo/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_payairo/layout/core'
import { MasterInit } from '../_payairo/layout/MasterInit'
import { AuthInit, useAuth } from './modules/auth'
import { ThemeModeProvider } from '../_payairo/partials'
import { ToastProvider } from './hooks/useToast'
import { ToastContainer } from './components/ToastNotification'
import { getDashboardPath, normalizeRoleKey } from './utils/helper'

export type ProtectedRouteProps = {
  children: ReactElement
  /** e.g. Spectator, Manager — Developer included so existing Spectator flow stays unchanged */
  allowedRoles: string[]
}

export const ProtectedRoute: FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { currentUser, auth } = useAuth()
  const userType =
    currentUser?.user_type || auth?.user_type || localStorage.getItem('user_type') || ''
  const role = currentUser?.role || auth?.role || userType
  const key = normalizeRoleKey(role || userType)
  const allowed = allowedRoles.map((r) => normalizeRoleKey(r))
  if (!allowed.includes(key)) {
    return <Navigate to={getDashboardPath(role, userType)} replace />
  }
  return children
}

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <ToastProvider>
              <AuthInit>
                <Outlet />
                <MasterInit />
                <ToastContainer />
              </AuthInit>
            </ToastProvider>
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
